.section {
  border-bottom: 1px solid #ccc;
}

.sectionTitle {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  font-weight: 600;
}

.drawerHeader {
  border-top: 1px solid #ccc;
}

.fieldGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  align-items: start;
}

.fieldGrid > * {
  min-width: 0;
}

.fullWidth {
  grid-column: 1 / -1;
}

.selectItem {
  width: 200px;
}

/*
 * Sash renders a select holding a single option as transparent, which overrides the grey
 * background it gives disabled inputs. A select that is disabled because nothing has been
 * chosen upstream holds only its placeholder, so it would otherwise read as enabled.
 */
.selectItem[disabled] {
  background-color: var(--color-neutral-50);
}

.toggleGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}

.toggleItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.inputToggleItem {
  grid-column: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.inputPromptItem {
  grid-column: 2;
}
